
import { Component, Vue, Prop } from 'vue-property-decorator'
import MainLayoutHeader from '../components/MainLayoutHeader.vue'
import { useSettingStore } from '@/store/setting'

@Component({
  name: 'BuildinLayoutTop',
  components: { MainLayoutHeader },
})
export default class extends Vue {
  @Prop({ type: String })
  private theme!: 'light' | 'dark'

  // 是否顶部导航固定
  @Prop({ type: Boolean })
  private fixedHeader!: boolean

  @Prop({ type: String })
  private bgColor!: string

  private settingStore = useSettingStore()

  protected get contentTop() {
    const breadHeight = this.$slots.bread ? 31 : 0
    const tabHeight = this.$slots.tab ? 52 : 0
    return this.fixedHeader ? breadHeight + tabHeight + 64 + 'px' : 0
  }
}
